import { render } from "./leftPanel.html?vue&type=template&id=123d723b&scoped=true"
import script from "./LeftPanel.vue?vue&type=script&lang=ts"
export * from "./LeftPanel.vue?vue&type=script&lang=ts"

import "./leftPanel.scss?vue&type=style&index=0&id=123d723b&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-123d723b"

export default script